import React from 'react'
import { Modal } from 'antd'

import CustomButton from '../../Components/CustomButton'
import { deleteCampaign, getCampaign } from '../../redux/actions/campaignaction';
import { useSelector } from 'react-redux';



const DeleteModal = ({ visible, onClose,currentRoute,setNotificationmodal,deletecomp,selectedCampaignId}) => {
  const user = useSelector((state) => state?.Auth?.userDetails?.user)
   
  const cancel = () => {
    // setPlayerInfo({})
    onClose()
  }

const onsave=async()=>{

try {

  if (selectedCampaignId.length > 0){
    const validCampaignIds = selectedCampaignId.filter(id => typeof id === 'string');
    const res = await deleteCampaign({ ids: validCampaignIds })

    if (res?.data){
      cancel()
      setNotificationmodal(true)

      const orgId = user?.organizationid || localStorage.getItem('organizationid')
      if (orgId) {
        await getCampaign({ organizationid: orgId, page: 1 })
      }
    }

  }


} catch (error) {

  console.log('error',error);

}

}

  return (
    <Modal
      className='deletemodal'
      title=''
      open={visible}
      onCancel={onClose}
      centered
     footer={[
        
      
        
      ]}
      
    >
   
<h1>
  {currentRoute === '/dashboard/my-campaigns' || deletecomp ? 'Delete Campaign?' : 'Delete User?'}
</h1>



{/* <p>

{currentRoute === '/dashboard/my-campaigns' ||  deletecomp ? 'Do you want to delete this campaign.' : 'Do you want to delete this user.'}

</p> */}


<p>
  {currentRoute === '/dashboard/my-campaigns' 
    ? (selectedCampaignId?.length > 1 ? `Do you want to delete ${selectedCampaignId?.length } campaign.` : 'Do you want to delete this campaign.')
    : deletecomp 
      ? 'Do you want to delete this campaign.'
      : 'Do you want to delete this user.'}
</p>


<div className='btn'>

   <CustomButton onClick={onsave} text={'Yes'}/>


   <CustomButton onClick={cancel} text={'No'}/>
 
</div>
    </Modal>




  )
}

export default DeleteModal
